module.exports = __webpack_public_path__ + "media/images/shared/logo-angelport-c1c3aa7ed62b5d11451a7604cf58e662.svg";